import { Modal } from 'src/components/design-system';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import Image from 'next/image';

interface Props {
  setIsModalOpen: (value: boolean) => void;
  isOpen: boolean;
}

export const SuccessModal: FC<Props> = (props) => {
  const t = useTranslations('business');

  return (
    <Modal
      whiteHeader
      size="md"
      onClose={() => {
        props.setIsModalOpen(false);
      }}
      isOpen={props.isOpen}
    >
      <div className="px-5 text-center">
        <div className="text-center border-greyscale-gray-light">
          <Image
            className="py-4 mx-auto object-contain"
            src={
              'https://upload.wikimedia.org/wikipedia/commons/5/51/Green-checkmark.svg'
            }
            width={120}
            height={120}
            alt="Done!"/>
          <h3 className="font-bold">{t('SuccessModal.Title')}</h3>
        </div>
        <h6 className="text-balance">{t('SuccessModal.Subtitle')}</h6>
        <div className="inline-block" style={{ width: '50px', height: '60px' }} />
      </div>
      <div
        className="inline-block"
        style={{ width: '50px', backgroundColor: 'white', height: '60px' }}
      ></div>
    </Modal>
  );
};
